import { render, staticRenderFns } from "./CustomersChartsTabPane.vue?vue&type=template&id=44fed08d&scoped=true"
import script from "./CustomersChartsTabPane.vue?vue&type=script&lang=js"
export * from "./CustomersChartsTabPane.vue?vue&type=script&lang=js"
import style0 from "./CustomersChartsTabPane.vue?vue&type=style&index=0&id=44fed08d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fed08d",
  null
  
)

export default component.exports